export function formatDurationAndTime(inTime, outTime) {
   const formatTime = (date) =>
    date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });

  if(inTime != "" && outTime != "") {
   const start = new Date(inTime);
   const end = new Date(outTime);

   const diffMs = end - start;
   const diffMins = Math.floor(diffMs / 60000);

    return {
      minstext: `${diffMins} Mins`,
      timestrng: `${formatTime(start)} - ${formatTime(end)}`
    };
  } else if(inTime != "" && outTime == "") {
      const start = new Date(inTime);

      return {
        minstext: `0 Mins`,
        timestrng: `${formatTime(start)} - `
      };
  } else if(inTime == "" && outTime != "") {
      const end = new Date(outTime);

      return {
        minstext: `0 Mins`,
        timestrng: `Null - ${formatTime(end)}`
      }; 
  } else if(inTime == "" && outTime == "") {
      
      return {
        minstext: `0 Mins`,
        timestrng: ""
      };        
  }

}


export function dateFormatAndDay(datestr) {
    let formattedDate = "";
    let daystrng = "";
    if(datestr) {
      let date = new Date(datestr);

      formattedDate = date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

      const fullDays = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
      daystrng = fullDays[date.getDay()];
    }

    return {
        formatteddate: formattedDate,
        daystrng: daystrng
      };    

}

export function snglDateRngFormat(datestr) {
  let formattedDate = "";
  let formatteddateTime = "";
  let formatteddateTimeRng = {};

  if (datestr) {
    const date = new Date(datestr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-GB", { month: "short" });
    const year = date.getFullYear();

    formattedDate = `${day}-${month}-${year}`;
    formatteddateTime = `${formattedDate} 00:00:00`;
    formatteddateTimeRng = {
      startDate: `${formattedDate} 00:00:00`,
      endDate: `${formattedDate} 23:59:59`,
    };
  }

  return {
    formatteddate: formattedDate,
    formatteddateTime: formatteddateTime,
    formatteddateTimeRng: formatteddateTimeRng,
  };
}


export function snglDateFormat(datestr) {
  let formattedDate = "";
  if (datestr) {
    const date = new Date(datestr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-GB", { month: "2-digit" });
    const year = date.getFullYear();

    formattedDate = `${year}-${month}-${day}`;
  }

  return formattedDate;
}